module.exports = __webpack_public_path__ + "img/robot_active.1c45c64a.svg";